export const configureHotmartAffiliate = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const hotmartAffiliateId =
    urlParams.get('ref') || sessionStorage.getItem('hotmartAffiliateId')

  if (hotmartAffiliateId) {
    sessionStorage.setItem('hotmartAffiliateId', hotmartAffiliateId)
  }
}
